module.exports = __webpack_public_path__ + "img/venezuela.2452f95e.svg";